import React from "react";
import { CalDate } from "../../../utilities/functions";

const FirstReminderCell = ({ row }) => {
  return <div>{row?.firstReminder ? CalDate(row.firstReminder) : ""}</div>;
};

export default FirstReminderCell;
